import { api } from "@/lib/axios";
import dayjs from "dayjs";

const downloadReport = async ({
  path,
  name,
  startDate,
  endDate,
}: {
  path: string;
  name: string;
  startDate?: Date;
  endDate?: Date;
}) => {
  const response = await api
    .get(`/reports/${path}`, {
      params: {
        startDate: dayjs(startDate).format("YYYY-MM-DD"),
        endDate: dayjs(endDate).format("YYYY-MM-DD"),
      },
      responseType: "text",
    })
    .catch(() => null);

  if (response) {
    const csvString = response.data;

    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `HOMEPLUS_${name}_${dayjs().format("YYYYMMDDHHMMss")}.csv`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

export default downloadReport;
